export default __webpack_public_path__ + "43fcee2bfb9e25c610ee1a1475fa9c6d.svg";